import { apiPost, apiPostFile } from "./api";
import { workareaURLStyle } from "./workarea";

export function isRBR(file) {
  return /^\s*(?:Copy of )?(?:\w{3}_)?\d{6}_\d{8}_\d{4}(?:_eng)?(?:\s\(\d+\))?(?:\.txt)?(?:\s\d+)?$/.test(
    file.name
  );
}

export function getRBRFilename(file) {
  const searchRgx = /(\d{6}_\d{8}_\d{4}(?:_\d{10}|_Cervello)?)(?:.*\.)(\w{3})/g;
  const result = searchRgx.exec(file.name);
  return { filename: result[1], ext: result[2] };
}

export const handleRBRFileUpload = (
  file,
  workarea,
  organization,
  hasStaticCasts
) => {
  const { filename } = getRBRFilename(file);
  return apiPostFile(
    `/ctd/upload/rbr/${workareaURLStyle(
      workarea
    )}/${filename}?hasStaticCasts=${hasStaticCasts}&organization=${organization}`,
    file
  ).then(res => res.json());
};

export function isRsk(file) {
  return /^\s*(?:Copy of )?(?:\w{3}_)?\d{6}_\d{8}_\d{4}(?:_\d{10}|_Cervello)?(?:\s\(\d+\))?(?:\.rsk)?(?:\s\d+)?$/.test(
    file.name
  );
}

export const handleRskFileUpload = (
  file,
  workarea,
  organization,
  hasStaticCasts
) => {
  const { filename } = getRBRFilename(file);
  return apiPostFile(
    `/ctd/upload/rbr/${workareaURLStyle(
      workarea
    )}/rsk/${filename}?hasStaticCasts=${hasStaticCasts}&organization=${organization}`,
    file.stream(),
    { duplex: "half" }
  ).then(res => res.json());
};

export function isHex(file) {
  return /^\s*(?:Copy of )?\d{6}_\d{8}_\d{4}(?:\s\(\d+\))?(?:\.hex)?(?:\s\d+)?$/.test(
    file.name
  );
}

export const handleHexFileUpload = (
  file,
  workarea,
  organization,
  hasStaticCasts
) => {
  const { filename } = getRBRFilename(file);
  return apiPostFile(
    `/ctd/upload/rbr/${workareaURLStyle(
      workarea
    )}/hex/${filename}?hasStaticCasts=${hasStaticCasts}&organization=${organization}`,
    file
  ).then(res => res.json());
};

// Handle RBR annotate
export const handleRBRAnnotation = (casts, workarea, organization) =>
  apiPost(
    `/ctd/annotate/rbr/${workareaURLStyle(workarea)}/casts`,
    casts.map(cast => ({
      ctd_cast_pk: cast.ctdCastPk,
      cruise: cast.matchedForm.survey,
      station: cast.matchedForm.siteId,
      cast_number: cast.matchedForm.drop,
      status: cast.matchedForm.miscast ? "MISCAST" : undefined,
      latitude: cast.matchedForm.dropLat,
      longitude: cast.matchedForm.dropLong,
      target_depth: cast.matchedForm.targetDepthM,
      vessel: cast.matchedForm.vessel,
      operators: cast.matchedForm.fieldStaff,
      comments: cast.matchedForm.qualityLog,
      form_hakai_id: cast.matchedForm.hakaiId,
      organization: cast.matchedForm.organization || organization,
      start_dt: cast.startDt,
      bottom_dt: cast.bottomDt,
      manual_override_dt: cast.manualOverrideDt
    }))
  );
